import { render, staticRenderFns } from "./CrewDispatch.vue?vue&type=template&id=6e211e3d&lang=pug&"
import script from "./CrewDispatch.vue?vue&type=script&lang=js&"
export * from "./CrewDispatch.vue?vue&type=script&lang=js&"
import style0 from "./CrewDispatch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports